import React, { useState, useEffect } from 'react';
import MetaFieldConst from '../../common/variables/MetaFieldConst';
import ProgramStateConst from '../../common/variables/ProgramStateConst';
import OfferDisplayStatusConst from '../../common/variables/OfferDisplayStatusConst';
import BackendResponseProgramStatusConst from '../../common/variables/BackendResponsePerformanceStatusConst';
import Const from '../../common/variables/Const'
import {dateTimePrint} from '../../common/methods/CommonUtil'
import { useTranslation } from "react-i18next";

function Card(props) {
	const { t } = useTranslation();
	
	const [series, setSeries] = useState('');
	const [performance_title, setPerformance_title] = useState('');
	const [venue, setVenue] = useState('');
	const [thumbnail, setThumbnail] = useState('');
	const [offer_id, setOffer_id] = useState('');
	const [programState, setProgramState] = useState('');
	const [purchase_end_time, setPurchase_end_time] = useState('');
	const [performance_start_time, setPerformance_start_time] = useState('');
	const [frame_string, setFrameString] = useState('');
	const [archive_purchase_end_time, setArchivePurchaseEndTime] = useState();
	const [offerPageUrl, setOfferPageUrl] = useState('');

	const displayStatus = OfferDisplayStatusConst.normal
	
	useEffect(() => {
		// クエリパラメーター取得
		/*
		if (props.selectedDistributorId) {
			//公演詳細のクエリパラメータありのリンクを作成
			setOfferPageUrl(`/offer/${offer_id}` + Const.newDistributorQueryNonSlash + props.selectedDistributorId)
		} else {
			//公演詳細のリンクを作成
			setOfferPageUrl(`/offer/${offer_id}`)
		}
		*/
		//公演詳細のリンクを作成
		setOfferPageUrl(`/offer/${offer_id}`)
	}, [offer_id]);
	
	useEffect(() => {
		let metaJson = props.offerJson.meta_struct;
		let startTime = '';
		let local_is_ensemble_cancelled;
		if (props.language === 'ja_JP') {
			setSeries(props.offerJson.series);
			setPerformance_title(props.offerJson.performance_title);
			setThumbnail(props.offerJson.performance_thumbnail);

			setFrameString('');
			metaJson.forEach(meta => {
				if (meta.meta_field_name === MetaFieldConst.venue) setVenue(meta.value);
				if (meta.meta_field_name === MetaFieldConst.pianoOfferId) setOffer_id(meta.value);
				if (meta.meta_field_name === MetaFieldConst.purchaseEndTime) setPurchase_end_time(meta.value);
				if (meta.meta_field_name === MetaFieldConst.performanceStartTime) startTime = meta.value;
				if (meta.meta_field_name === MetaFieldConst.frameString) setFrameString(meta.value);
				if (meta.meta_field_name === MetaFieldConst.archivePurchaseEndTime) setArchivePurchaseEndTime(meta.value);
				// 公演ステータス判定用
				if (meta.meta_field_name === MetaFieldConst.isEnsembleCancelled) local_is_ensemble_cancelled = meta.value;
			});
		} else if (props.language === 'en_US') {
			setSeries('');
			setThumbnail(props.offerJson.performance_thumbnail);
			setFrameString('');
			metaJson.forEach(meta => {
				if (meta.meta_field_name === MetaFieldConst.seriesTitleEn) setSeries(meta.value);
				if (meta.meta_field_name === MetaFieldConst.titleEn) setPerformance_title(meta.value);
				if (meta.meta_field_name === MetaFieldConst.venueEn) setVenue(meta.value);
				if (meta.meta_field_name === MetaFieldConst.pianoOfferId) setOffer_id(meta.value);
				if (meta.meta_field_name === MetaFieldConst.purchaseEndTime) setPurchase_end_time(meta.value);
				if (meta.meta_field_name === MetaFieldConst.performanceStartTime) startTime = meta.value;
				if (meta.meta_field_name === MetaFieldConst.frameStringEn) setFrameString(meta.value);
				if (meta.meta_field_name === MetaFieldConst.archivePurchaseEndTime) setArchivePurchaseEndTime(meta.value);
				// 公演ステータス判定用
				if (meta.meta_field_name === MetaFieldConst.isEnsembleCancelled) local_is_ensemble_cancelled = meta.value;
			});
		}
		setPerformance_start_time(new Date(startTime));

		// 公演ステータス判定
		switch (props.offerJson.performance_status) {
			case BackendResponseProgramStatusConst.waitSale:
				setProgramState(ProgramStateConst.waitSale); //販売前
				break;
			case BackendResponseProgramStatusConst.onSale:
				if (props.offerJson.isLivePurchased) {
					if (props.offerJson.is_streaming) {
						setProgramState(ProgramStateConst.streaming); // 配信中
					} else {
						setProgramState(ProgramStateConst.purchased); // 購入済み
					}
				} else {
					setProgramState(ProgramStateConst.onSale); //販売中
				}
				break;
			case BackendResponseProgramStatusConst.unavailable:
				if (props.offerJson.isLivePurchased) {
					if (props.offerJson.is_streaming) {
						setProgramState(ProgramStateConst.streaming); // 配信中
					} else {
						setProgramState(ProgramStateConst.purchased); // 購入済み
					}
				} else {
					setProgramState(ProgramStateConst.unavailable); //販売終了
				}
				break;
			case BackendResponseProgramStatusConst.rerun:
				if (props.offerJson.isLivePurchased) {
					setProgramState(ProgramStateConst.rerun); // 見逃し配信中
				} else {
					setProgramState(ProgramStateConst.done); //公演終了
				}
				break;
			case BackendResponseProgramStatusConst.archiveInPreparation:
				setProgramState(ProgramStateConst.archiveInPreparation); //アーカイブ準備中
				break;
			case BackendResponseProgramStatusConst.archiveOnSale:
				if (props.offerJson.isArchivePurchased) {
					if (props.offerJson.is_streaming) {
						setProgramState(ProgramStateConst.archive); // アーカイブ配信中
					} else {
						setProgramState(ProgramStateConst.purchased); // 購入済み
					}
				} else {
					setProgramState(ProgramStateConst.onSale); //販売中
				}
				break;
			case BackendResponseProgramStatusConst.archiveUnavailable:
				if (props.offerJson.isArchivePurchased) {
					if (props.offerJson.is_streaming) {
						setProgramState(ProgramStateConst.archive); // 配信中
					} else {
						setProgramState(ProgramStateConst.purchased); // 購入済み
					}
				} else {
					setProgramState(ProgramStateConst.unavailable); //販売終了
				}
				break;
			default:
				setProgramState(ProgramStateConst.done); //公演終了
				break;
		}
		//中止処理
		if (local_is_ensemble_cancelled) {
			setProgramState(ProgramStateConst.cancelled); // 公演中止
		}
	}, [props]);

	return (
		<React.Fragment>
			<div className={`card ${programState === ProgramStateConst.streaming ? 'performance--live' : programState === ProgramStateConst.done ? 'performance--close' : programState === ProgramStateConst.unavailable ? 'performance--endofsales' : programState === ProgramStateConst.cancelled ? 'performance--endofsales' : programState === ProgramStateConst.rerun ? 'performence--live' : programState === ProgramStateConst.archive ? 'performence--live' : programState === ProgramStateConst.end ? 'performence--endofsales' : ''}`}>
				<a href={offerPageUrl} className="card__inner">
					<div className="card-header">
						<div className="card-header__date">
							{dateTimePrint(props.language , performance_start_time, 'MMDD')}
							<br className="sp-only" />
							{dateTimePrint(props.language , performance_start_time, 'HHMM')}
							<br className="sp-only" />
							{t("offer.start")}
						</div>
						<div className="card-header__tag sp-only">
							<div className={`card-tag performance__status ${programState === ProgramStateConst.waitSale ? 'card-tag--wait' : programState === ProgramStateConst.streaming ? 'card-tag--live' : programState === ProgramStateConst.purchased ? 'card-tag--purchased' : programState === ProgramStateConst.onSale ? 'card-tag--sale' : programState === ProgramStateConst.done ? 'card-tag--end' : programState === ProgramStateConst.unavailable ? 'card-tag--end' : programState === ProgramStateConst.cancelled ? 'card-tag--cancelled' : programState === ProgramStateConst.rerun ? 'card-tag--rerun' : programState === ProgramStateConst.archive ? 'card-tag--archive' : programState === ProgramStateConst.archiveInPreparation ? 'card-tag--archive-preparation' : 'card-tag--other'}`}>
								{getProgramState(programState,t)}
							</div>
						</div>
					</div>
					<div className="card-thumbnail">
						<div className="card-thumbnail__inner">
							{thumbnail !== '' ? <img src={thumbnail} alt="thumbnail" /> : <img src="./assets/img/common/thumbnail-default.jpg" alt="thumbnail" />}
						</div>
						<div className="card-thumbnail__grad"></div>
						{props.smallLogoUrl ?
							<div className="card-thumbnail__logo"><img src={props.smallLogoUrl} alt="" /></div>
							: ''
						}
					</div>
					<div className="card-body">
						<div className="card-tags pc-only">
							<div className={`card-tag performance__status ${programState === ProgramStateConst.waitSale ? 'card-tag--wait' : programState === ProgramStateConst.streaming ? 'card-tag--live' : programState === ProgramStateConst.purchased ? 'card-tag--purchased' : programState === ProgramStateConst.onSale ? 'card-tag--sale' : programState === ProgramStateConst.done ? 'card-tag--end' : programState === ProgramStateConst.unavailable ? 'card-tag--end' : programState === ProgramStateConst.cancelled ? 'card-tag--cancelled' : programState === ProgramStateConst.rerun ? 'card-tag--rerun' : programState === ProgramStateConst.archive ? 'card-tag--archive' : programState === ProgramStateConst.archiveInPreparation ? 'card-tag--archive-preparation' : ''}`}>
								{getProgramState(programState,t)}</div>
							{frame_string !== '' ? <div className="card-tag performance__movie-type">{frame_string}</div> : ''}
						</div>
						<div className="card-body__category">{series}</div>
						<div className="card-body__title">{performance_title}</div>
						<div className="card-body__place">{venue}</div>
						<div className="card-body__deadline">
							{displayStatus === OfferDisplayStatusConst.archive
								? archive_purchase_end_time ? t("offer.purchasedPeriod") + "：" + dateTimePrint(props.language , archive_purchase_end_time, 'YYYYMMDD') : ''
								: purchase_end_time ? t("offer.purchasedPeriod") + "：" + dateTimePrint(props.language , purchase_end_time, 'YYYYMMDD') : ''
							}
						</div>
						<div className="card-tags sp-only">
							{frame_string !== '' ? <div className="card-tag performance__movie-type">{frame_string}</div> : ''}
						</div>
					</div>
				</a>
			</div>
		</React.Fragment>
	);
}

function getProgramState(key , t) {
	switch (key) {
		case ProgramStateConst.purchased:
			return t("ticketStatus.purchased");
		case ProgramStateConst.streaming:
			return t("ticketStatus.streaming");
		case ProgramStateConst.done:
			return t("ticketStatus.done");
		case ProgramStateConst.onSale:
			return t("ticketStatus.onSale");
		case ProgramStateConst.waitSale:
			return t("ticketStatus.waitSale");
		case ProgramStateConst.unavailable:
			return t("ticketStatus.unavailable");
		case ProgramStateConst.cancelled:
			return t("ticketStatus.cancelled");
		case ProgramStateConst.rerun:
			return t("ticketStatus.rerun");
		case ProgramStateConst.archive:
			return t("ticketStatus.archive");
		case ProgramStateConst.archiveInPreparation:
			return t("ticketStatus.archiveInPreparation");
		default:
			return t("ticketStatus.prepair");
	}
}


export default Card;
